import angular from 'angular'

import { OnboardingApplicationModule } from './application/onboarding-application.module';
import { OnboardingPolicyModule } from './policy/onboarding-policy.module';
import { OnboardingRosterService } from './onboarding-roster.service'
import { EditSgiIdAssignmentModalComponent } from './edit-sgi-id-assignment/edit-sgi-id-assignment-modal.component';
import { SgiIdAssignmentReportComponent } from './sgi-id-assignment-report/sgi-id-assignment-report.component'
import { OnboardingRoutingModule } from './onboarding-routing.module';

export const OnboardingModule = angular
    .module("apex.mainApp.onboarding", [
        OnboardingApplicationModule,
        OnboardingPolicyModule,
        OnboardingRoutingModule
    ])
    .factory("onboardingRosterService", OnboardingRosterService)
    .component("apexEditSgiIdAssignmentModal", EditSgiIdAssignmentModalComponent)
    .component("apexSgiIdAssignmentReport", SgiIdAssignmentReportComponent)
    .name
